import { NavigateOptions, URLSearchParamsInit } from 'react-router-dom'
import { PageQuery } from '../../../utils/models/pageQuery'

// Every URL key this module owns. usePageQuery uses the list to tell managed
// params from foreign deep-link params (which must be preserved, never
// rewritten) and to classify a write as normalization vs. user action.
export const MANAGED_QUERY_KEYS = [
  'searchTerm',
  'pageSize',
  'pageIndex',
  'sortByField',
  'sortDirection',
  'filterBy',
  'filterOn',
  'open',
  'orgId'
] as const

export function buildQueryParameters(currentPageQuery: PageQuery): Record<string, string | string[]> {
  const qP = {
    searchTerm: currentPageQuery.searchTerm,
    pageSize: '' + currentPageQuery.page?.size,
    pageIndex: '' + currentPageQuery.page?.index,
    sortByField: currentPageQuery.sortBy?.field,
    sortDirection: currentPageQuery.sortBy?.sortDirection ? '' + currentPageQuery.sortBy?.sortDirection : '',
    filterBy: currentPageQuery.filterBy?.map(x => x.field),
    filterOn: currentPageQuery.filterBy?.map(x => x.value),
    open: '' + currentPageQuery.open?.id,
    orgId: '' + currentPageQuery.open?.organizationId
  }

  // removes keys with undefined values from model
  const clone = Object.assign({}, qP)
  for (const key in clone) {
    // @ts-ignore
    if (!clone[key] || clone[key] === 'undefined') {
      // @ts-ignore
      delete qP[key]
    }
  }

  return qP as Record<string, string | string[]>
}

export function setQueryParameters(setQParams: (nextInit?: (URLSearchParamsInit | ((prev: URLSearchParams) => URLSearchParamsInit)), navigateOpts?: NavigateOptions) => void, currentPageQuery: PageQuery, navigateOpts?: NavigateOptions) {
  setQParams(() => buildQueryParameters(currentPageQuery), navigateOpts)
}
